// extracted by mini-css-extract-plugin
module.exports = {"Inputs":"style_Inputs__2rVgM"};